import React from "react"
import styled from "styled-components"

import { Section, Container } from "../global"

const FAQS = [
  {
    q: "What's a perfect day?",
    a: "Whatever you say it is. You set your intentions — the small things that make a day feel right to you — and any day you live them is a perfect day. Add it to the app with one tap and your sun goes up.",
  },
  {
    q: "How does the 16-hour cooldown work?",
    a: "After you add a day, there's a 16-hour cooldown before you can add the next one. It keeps a \"day\" honest without forcing you onto a rigid midnight clock — early birds and night owls both fit.",
  },
  {
    q: "Is the Bitcoin real?",
    a: "Yes. You earn BTC points by adding days, keeping streaks, and catching golden suns, and points convert into real sats payouts. It's a reward for showing up — not an investment product, and not financial advice.",
  },
  {
    q: "Are shared notes anonymous?",
    a: "Yes, completely. When a note from your day is shared with the community, it carries no name, no avatar, and no profile link — ever. It's just a real note from a real day.",
  },
  {
    q: "What happens if I miss a day?",
    a: "The sun rises anyway. Missing days is part of being human, and Day never guilts you about it. Come back whenever you're ready and pick up where you left off.",
  },
  {
    q: "How much does Day cost?",
    a: "Nothing. Day is free to download and free to use, with no fees on your Bitcoin rewards. If you love it, you can support the community with an optional monthly contribution.",
  },
]

const FAQ = () => (
  <StyledSection id="faq">
    <StyledContainer>
      <Subtitle>Questions</Subtitle>
      <SectionTitle>Good things to know</SectionTitle>
      <FAQList>
        {FAQS.map((item) => (
          <FAQItem key={item.q}>
            <summary>{item.q}</summary>
            <p>{item.a}</p>
          </FAQItem>
        ))}
      </FAQList>
    </StyledContainer>
  </StyledSection>
)

export default FAQ

const StyledSection = styled(Section)`
  background: ${(props) => props.theme.color.background.light};
`

const StyledContainer = styled(Container)``

const SectionTitle = styled.h3`
  color: ${(props) => props.theme.color.primary};
  display: flex;
  justify-content: center;
  margin: 0 auto 40px;
  text-align: center;
`

const Subtitle = styled.h5`
  font-size: 16px;
  color: ${(props) => props.theme.color.accent};
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 12px;
  text-align: center;
`

const FAQList = styled.div`
  max-width: 720px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 0 16px;
`

const FAQItem = styled.details`
  background: white;
  border: 1px solid #ffe9c7;
  border-radius: 16px;
  padding: 18px 24px;

  summary {
    cursor: pointer;
    font-family: ${(props) => props.theme.font.semibold};
    color: ${(props) => props.theme.color.primary};
    font-size: 17px;
    outline: none;

    &::marker {
      color: ${(props) => props.theme.color.accent};
    }
  }

  p {
    margin: 14px 0 0;
    color: ${(props) => props.theme.color.black.light};
    line-height: 26px;
  }

  &[open] {
    box-shadow: 0 8px 24px rgba(219, 152, 64, 0.12);
  }
`
